import { render, staticRenderFns } from "./paramScroll.vue?vue&type=template&id=29207844&scoped=true&"
import script from "./paramScroll.vue?vue&type=script&lang=js&"
export * from "./paramScroll.vue?vue&type=script&lang=js&"
import style0 from "./paramScroll.vue?vue&type=style&index=0&id=29207844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29207844",
  null
  
)

export default component.exports